import { useSpotDetailAttachedStateMachine } from './useSpotDetailAttachedStateMachine'
import { useStampFlowStateMachine } from './useStampFlowStateMachine'

type SpotDetailStateMachineOptions = {
  isBarCodeWithGPS: boolean
  isQRCodeWithGPS: boolean
  isKeywordWithGPS: boolean
  /** キャンペーン情報を取得済みか。GPS 併用フラグの既定値 false と「未取得」を区別するために渡す */
  isCampaignLoaded: boolean
}

/**
 * スポット詳細ページの統合フック。
 * - useStampFlowStateMachine: スタンプ獲得フロー（メインロジック）
 * - useSpotDetailAttachedStateMachine: 音声ガイド・ARフォトのダイアログ制御
 */
export const useSpotDetailStateMachine = (spotId: number, options: SpotDetailStateMachineOptions) => {
  const stamp = useStampFlowStateMachine(spotId, options)
  const attached = useSpotDetailAttachedStateMachine()

  return {
    stamp,
    attached,
  }
}
